import { TableRootClientes } from "./Components/table/TableRootClientes";

export const PageRootClientes = () => {
  return <TableRootClientes />;
};
